import { StepperProvider } from "../components/stepper-provider";
import Stepper from "../components/stepper";
import React from "react";
// import { redirect } from "next/navigation";
import EditDistributionProject from ".";
import Navbar from "@/components/top-nav";
import { useParams } from "react-router-dom";

export default  function DistributionEditProjectLayout() {
  const { id } = useParams();
  return (
    <StepperProvider>
      <Navbar/>
      <Stepper />
      
      <EditDistributionProject projectId={id} />
    </StepperProvider>
  );
}
